import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { getInstance } from '../services/api';
import { Box } from '@mui/material';
import Loader from '../components/common/loaderComponent/Loader';


interface InstanceContextType {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  instance: any;       // type if you have it
  loading: boolean;
  error: string | null;
}

const InstanceContext = createContext<InstanceContextType | undefined>(undefined);

export const InstanceProvider: React.FC<{ children: ReactNode }> = ({ children }) => {


  const [instance, setInstance] = useState<unknown>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // 🔥 CALL getInstance ONLY ONCE when app loads (or when user changes)
  useEffect(() => {

    const fetchInstance = async () => {
      try {
        const data = await getInstance('');   // ⭐ Using your API function
        setInstance(data);
      } catch (err) {
        setError('Failed to fetch instance.');
      } finally {
        setLoading(false);
      }
    };

    fetchInstance();
  }, []); // Runs once unless token changes

  if(loading)
    return(<Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}
    >
      <Loader />
    </Box>);

  return (
    <InstanceContext.Provider value={{ instance, loading, error }}>
      {children}
    </InstanceContext.Provider>
  );
};

export const useInstance = (): InstanceContextType => {
  const ctx = useContext(InstanceContext);
  if (!ctx) throw new Error('useInstance must be used within InstanceProvider');
  return ctx;
};
